import {UI} from "../../../../../stem-core/ui/UIBase";
import {UserDashboardSection} from "./UserDashboardSection.jsx";
import {Link} from "../../../../../stem-core/ui/primitives/Link";

export function UserDashboardCDSAccountSection(cdsSocialAccount) {
    if (!cdsSocialAccount) {
        return null;
    }

    const cdsAccountNumber = cdsSocialAccount.getCDSAccountNumber();

    const cdsURL = "https://service.newrepublic.com/login?redirect=%2F";

    return <UserDashboardSection titleMessage="Account Number">
        <div>
            Your customer support account number is <strong>{cdsAccountNumber}</strong>.
        </div>
        <div>
            Manage your subscription account <Link newTab href={cdsURL} label="here"/>.
        </div>
    </UserDashboardSection>;
}
